import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { ShieldCheck, Loader2 } from 'lucide-react';
import { AydinlatmaVersionsCard } from './AydinlatmaVersionsCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AydinlatmaMetniCard = () => {
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    axios.get(`${API}/public/aydinlatma-metni`).then(res => setText(res.data.text)).catch(() => {});
  }, [refreshKey]);

  const save = async () => {
    setSaving(true);
    try {
      const res = await axios.put(`${API}/settings/aydinlatma-metni`, { text });
      if (res.data.changed) toast.success(`Yeni sürüm kaydedildi: v${res.data.version}. Firmalardan yeniden onay istenecek.`);
      else toast.info('Metinde değişiklik yok');
      setRefreshKey(k => k + 1);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Kaydedilemedi');
    } finally { setSaving(false); }
  };

  return (
    <>
    <Card className="border-slate-200" data-testid="aydinlatma-metni-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5" />İSG Permit Aydınlatma Metni</CardTitle>
        <CardDescription>Firma kayıt ekranında gösterilen ve "Okudum ve anladım" onayı alınan metin.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={14} className="text-sm" data-testid="aydinlatma-metni-textarea" />
        <div className="flex justify-end">
          <Button onClick={save} disabled={saving || !text.trim()} className="bg-slate-900 hover:bg-slate-800" data-testid="aydinlatma-metni-save">
            {saving && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Kaydet
          </Button>
        </div>
      </CardContent>
    </Card>
    <AydinlatmaVersionsCard refreshKey={refreshKey} onRestored={() => setRefreshKey(k => k + 1)} />
    </>
  );
};
